export enum FufiCoverageCode {
    ReleaseCoverage = "5000",
    ZprnK1u = "ZPRN-K1U",
}